import { DEPLOY_ENV, deployEnv } from "./environment";
import { WEB_TYPE, webType } from "./webType";

export const WEB_TYPE_API_URL_CONFIG = {
  [DEPLOY_ENV.DEV]: {
    [WEB_TYPE.TUTORABC]: {
      MessageAPI: "http://localhost:7132",
      LIFF: {
        BindingStaffLineUserId: "https://liff.line.me/1654213699-EP2oXzD3",
      },
    },
    [WEB_TYPE.TUTORABC_CN]: {
      MessageAPI: "http://localhost:7132",
      LIFF: {
        BindingStaffLineUserId: "liff.line.me/1654213699-EP2oXzD3",
      },
    },
  },
  [DEPLOY_ENV.STAGE]: {
    [WEB_TYPE.TUTORABC]: {
      MessageAPI: "https://stagescrm.tutorabc.com/messagingservice",
      LIFF: {
        BindingStaffLineUserId: "https://line.me/R/app/1627783021-39vngRmk",
      },
    },
    [WEB_TYPE.TUTORABC_CN]: {
      MessageAPI: "http://scrm-stage.zzmagic.com/messagingservice",
      LIFF: {
        BindingStaffLineUserId: "https://line.me/R/app/1627783021-39vngRmk",
      },
    },
  },
  [DEPLOY_ENV.PRE]: {
    [WEB_TYPE.TUTORABC]: {
      MessageAPI: "https://scrm-pre.tutorabc.com/messagingservice",
      LIFF: {
        BindingStaffLineUserId: "https://line.me/R/app/1506488852-NdKmGmxe",
      },
    },
    [WEB_TYPE.TUTORABC_CN]: {
      MessageAPI: "",
    },
  },
  [DEPLOY_ENV.PROD]: {
    [WEB_TYPE.TUTORABC]: {
      MessageAPI: "https://scrm.tutorabc.com/messagingservice",
      LIFF: {
        BindingStaffLineUserId: "https://line.me/R/app/1506488852-NdKmGmxe",
      },
    },
    [WEB_TYPE.TUTORABC_CN]: {
      MessageAPI: "https://scrm.newtutorabc.com.cn/messagingservice",
    },
  },
};
export const webTypeApiUrl = WEB_TYPE_API_URL_CONFIG[deployEnv][webType];



// WEBPACK FOOTER //
// ./src/constants/webTypeApiUrl.js